mp-gdpr-banner
  bottom 0
  left 0
  position fixed
  width 100%
  z-index 16777271 // max across all browsers

:host
  bottom 0
  left 0
  position fixed
  width 100%
  z-index 16777271 // max across all browsers

.mp23-brand.gdpr-banner-container
  background linear-gradient(360deg, #FBF9F9 0%, #FBF9F9 100%) // base80
  border-radius 16px
  box-shadow 0px 0px 30px rgba(48, 20, 109, 0.2)
  color #626266 // grey80
  font-family Garnett
  font-size 16px
  font-weight 400
  letter-spacing 0.02em
  margin 24px
  padding 16px
  width 684px

  .gdpr-banner-content
    display flex
    flex-direction column
  
  .gdpr-banner-buttons
    display flex
    margin-top 16px
  
  .button
    border-radius 100px
    cursor pointer
    font-family Garnett
    font-size 14px
    font-weight 500
    letter-spacing 0.02em
    padding 12px 24px
    transition color 0.15s ease, border-radius 0.15s ease, background-color 0.15s ease, background-image 0.15s ease, transform 0.15s ease, filter 0.15s ease

    &:hover
      border-radius 8px
      box-shadow 0 4px 15px rgba(176, 148, 255, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.5)
      transform scale(1.05)

  .gdpr-banner-accept-button
    background-color #7856FF // purple100
    background-image linear-gradient(2deg, #7856ff 0.97%, #9075ff 96.96%)
    border none
    color white

  .gdpr-banner-dismiss-button
    background-color white
    border 2px solid #5028C0 // purple140
    color #5028C0 // purple140
    margin-left 8px

  a
    color #626266 // grey80
    text-decoration underline
    
    &:hover
      background-color #e8ddff // purple20

  .gdpr-banner-dismiss
    color #1B0B3B // purple200
    opacity 1
    position initial

.gdpr-banner-container
  align-items flex-start
  background rgba(255, 255, 255, 0.9)
  display flex
  flex-direction column
  height 100%
  opacity 1
  padding 20px
  transition opacity 0.4s

  &.hidden
    height 0
    opacity 0
    pointer-events none
    transition opacity 0.4s, height 0s ease 0.4s

  a
    color #1868FB
    text-decoration none

  .gdpr-banner-text
    color #5B6271
    font-size 14px
    line-height 18px
    margin-top 3px
    max-width 970px

  .gdpr-banner-accept
    background-color #1868FB
    border-color transparent
    border-radius 4px
    color white
    cursor pointer
    display inline-block
    font-family 'Apercu Pro', 'Helvetica Neue', 'Helvetica', 'Tahoma', 'Geneva', 'Arial', sans-serif
    font-size 14px
    font-weight 500
    height 32px
    margin-top 1em
    white-space nowrap

    &:hover
      background-color #004FE2

  .gdpr-banner-dismiss
    background none
    border none
    box-shadow none
    cursor pointer
    opacity 0.3
    outline none
    position absolute
    right 0
    top 7px
    transition opacity 0.2s

    .svg-icon
      color #5B6271
      display inline-block
      height 22px
      min-height 22px
      min-width 22px
      position relative
      width 22px

      svg
        display block
        height 22px
        left 0
        min-height 22px
        min-width 22px
        position absolute
        top 0
        width 22px

    &:hover
      svg
        color #37383C

@media screen and (min-width: 600px)
  .gdpr-banner-container
    flex-direction row
    justify-content center
    padding 32px 86px

    .gdpr-banner-dismiss
      right 12px
      top 20px

    .gdpr-banner-accept
      margin-left 32px
      margin-top 0
